import { useMutation, UseMutationOptions } from 'react-query'
import { CreateCommentRequest, useNoteService } from '../services'
import { Comment } from 'hooks/services/useNoteService/types'

export const useCreateComment = (
  options?: Omit<UseMutationOptions<Comment, unknown, CreateCommentRequest, unknown>, 'mutationFn'>
) => {
  const { createComment } = useNoteService()

  return useMutation(createComment, options)
}
